import PropTypes from "prop-types"
import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import Container from "semantic-ui-react/dist/es/elements/Container/Container"
import Header from "semantic-ui-react/dist/es/elements/Header/Header"

const WorksheetRow = ({
  number,
  label,
  description,
  control,
  children,
  noTopBorder,
  error,
  level,
  paddedField,
  showNumbers = true,
  advancedField
}) => {
  let lhsClass = error ? "lighter-yellow" : ""
  let rhsClass = error
    ? "light-yellow grey-font"
    : `${advancedField ? "light" : "lighter"}-blue  grey-font`
  let fieldPadding = paddedField ? "extra-padding" : "regular-padding"
  return (
    <Grid.Row
      className={`${lhsClass} Worksheet__Row`}
      style={{ padding: "0px" }}
    >
      <Grid.Column width={10} textAlign="left" verticalAlign="middle">
        <Grid style={{ padding: "1em 2em 1em 2em" }} stackable={false}>
          <Grid.Row>
            {showNumbers ? (
              <Grid.Column width={1 + level} textAlign="right">
                <Header
                  as="h5"
                  style={{ fontSize: "1.125rem" }}
                >{`${number}.`}</Header>
              </Grid.Column>
            ) : level > 0 ? (
              <Grid.Column width={level} textAlign="right">
                {" "}
              </Grid.Column>
            ) : null}
            <Grid.Column
              width={number ? 14 - level : 16}
              textAlign={number ? "left" : "right"}
            >
              <Header
                as="h5"
                className={number ? "" : "italics"}
                style={{ fontSize: level > 0 ? "1rem" : "1.125rem" }}
              >
                {label}
                <Header.Subheader style={{ fontSize: "0.875rem" }}>
                  {description}
                </Header.Subheader>
              </Header>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
      <Grid.Column className={`${fieldPadding} ${rhsClass}`} width={6}>
        {error ? (
          <Container textAlign="center">
            {error.map((err, index) => (
              <p key={index} className="Worksheet__Row_ErrorSpan">
                {err}
              </p>
            ))}
          </Container>
        ) : null}
        {children}
      </Grid.Column>
    </Grid.Row>
  )
}

WorksheetRow.displayName = "WorksheetRow"

WorksheetRow.propTypes = {
  number: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  control: PropTypes.element,
  noBottomLine: PropTypes.bool
}

export default WorksheetRow
